import axios from 'axios';
import { put } from 'redux-saga/effects';

import { apiEndpoints } from '../../../../config/config';
import { Creators } from './actions';

// *************************** Fetch Single News Saga ***************************
export function* fetchSingleNewsSaga(action) {
  try {
    yield put(Creators.fetchSingleNewsStart());
    // console.log('fetch single news');
    let url, res;
    let singleNews = [];
    // console.log('action.postSlug: ', action.postSlug);
    if (action.postSlug !== null) {
      url = yield `${apiEndpoints.singleNews}/${action.postSlug}`;
      res = yield axios.get(url);
    } else {
      // console.log('Else');
      url = yield `${apiEndpoints.getMorePosts}/${action.timeStamp}`;
      res = yield axios.get(url);
    }
    // console.log('url: ', url);
    // console.log('res: ', res);
    // if (res.data.success === 1) {
    if (res.status === 200) {
      for (let key in res.data.post) {
        singleNews.push({
          id: key,
          ...res.data.post[key]
        });
      }
    }
    let payload = {
      postSlug: action.postSlug,
      singleNews: singleNews
    };
    // console.log('singleNews: ', singleNews);
    yield put(Creators.fetchSingleNewsSuccess(payload));
    let tagId, postId;
    if (res.data.post[0].tags && res.data.post[0].tags[0]) {
      tagId = res.data.post[0].tags[0];
    } else {
      tagId = null;
    }
    postId = res.data.post[0].id;
    // console.log('tagId: ', tagId);
    // console.log('postId: ', postId);
    yield put(Creators.fetchRelatedArticlesForSingleNews(tagId, postId));
  } catch (err) {
    yield put(Creators.fetchSingleNewsFailure(err));
  }
}
// ______________________________________________________________________________

// *************************** Fetch Related Articles Saga ***************************
export function* fetchRelatedArticlesForSingleNewsSaga(action) {
  // console.log('action: ', action);
  try {
    yield put(Creators.fetchRelatedArticlesForSingleNewsStart());
    let url, urlForFetchingTags;
    let relatedArticles = [],
      tagsList = [];
    if (action.tagId === null) {
      relatedArticles = [];
      tagsList = [];
    } else {
      url = yield `${apiEndpoints.relatedArticles}/${action.tagId}/${
        action.postId
      }`;
      urlForFetchingTags = yield `${apiEndpoints.fetchTagsList}/${
        action.postId
      }`;
      const res = yield axios.get(url);
      const resForTags = yield axios.get(urlForFetchingTags);
      if (res.data.success === 1) {
        for (let key in res.data.related) {
          relatedArticles.push({
            id: key,
            ...res.data.related[key]
          });
        }
      }

      // console.log('resForTags: ', resForTags);
      if (resForTags.data.success === 1) {
        for (let key in resForTags.data.tags) {
          tagsList.push({
            id: key,
            ...resForTags.data.tags[key]
          });
        }
      }
    }
    // console.log('relatedArticles: ', relatedArticles);
    yield put(
      Creators.fetchRelatedArticlesForSingleNewsSuccess({
        relatedArticles,
        tagsList
      })
    );
  } catch (err) {
    yield put(Creators.fetchRelatedArticlesForSingleNewsFailure(err));
  }
}
// ______________________________________________________________________________
